module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_blue.c13c1022.gif";